import { COLLECTIONS } from "constants/action-types";

import { ISuggestionItem } from "containers/product-collections/product-collection-cart";
export const setSuggestions = (data: ISuggestionItem[], storeKey: string) => {
    return {
        payload: {
            data,
            storeKey,
        },
        type: COLLECTIONS.COLLECTION.SUGGESTIONS.FETCH.START,
    };
};
